import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Partner, IStrapiDocuments } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
    selector: 'app-partner-banner',
    templateUrl: './partner-banner.component.html',
    styleUrls: ['./partner-banner.component.scss'],
    imports: [NgIf, RouterLink],
})
export class PartnerBannerComponent implements OnInit {
  @Input() partnerId: string | undefined | null = '';

  @Input() source: 'ACCOMMODATION' | 'UNIVERSITY' = 'ACCOMMODATION';

  public partner: Partner | null = <Partner | null>null;

  public desktopBackground: string = '';

  public appBackground: string = '';

  constructor(
    public readonly strapi: StrapiService,
    private readonly analyticsService: AnalyticsService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.partnerId) {
      this.strapi
        .getDocumentByUID('partners', this.partnerId, { populate: '*' })
        .subscribe((partner: IStrapiDocuments<Partner>) => {
          if (partner.data.length) {
            Promise.resolve().then(() => {
              this.partner = partner.data[0].attributes;
              this.cdr.detectChanges();
            });
          }
        });
    }
  }

  public trackEvent() {
    if (this.source !== 'UNIVERSITY') return;
    this.analyticsService.trackEvent('uni_partner_clicked', {
      source: 'WEB',
      partnerUUID: this.partnerId,
    });
  }
}
